import React from "react";
import { ActivityIndicator } from "react-native";
import { color as colorUtil } from "@sloth-system/styled-utils";
import theme from "../../configs/theme-config";

interface LoadingType {
  color: string;
}

function Loading(props: LoadingType) {
  return <ActivityIndicator color={colorUtil(props.color)({ theme: theme })} />;
}

export default Loading;
